/**
 * warning basically that says bassed on your configuration, it is likely that your configuration wont result in having 
 * a selectable option. As an example, it could be because the largest option price we have is a $1, and the 
 * user has selected a min price of $2.
 *{
	"messageType": "alertNotification",
	"notificationId": 1645453300407,
	"notificationDetails": {"warningType":"TRADE_PLAN_WARNING","notificationType":"WARNING","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "PRICE_OUTSIDE_OF_OPTION_RANGE",
	"statusDetails": {"maxPrice":2,"minPrice":1,"optionPrice":1.5},
	"date": "2022-02-21T09:21:40.966-0500",
	"timestamp": "1645453300970"
}

 * @param {*} statusDetails 
 * @returns object containing following fields...
 * 1) maxPrice: max option price the user would allow the option to be.
 * 
 * 2) minPrice: min option price the user would allow the option to be.
 * 
 * 3) optionPrice: largest possible option price based on filters
 * 
 */
export function priceOutsideOfOptionRangeFilter(statusDetails) {
  const parsedObj = {
    maxPrice: null,
    minPrice: null,
    optionPrice: null,
  };
  if (statusDetails) {
    parsedObj.maxPrice = statusDetails.maxPrice ?? null;
    parsedObj.minPrice = statusDetails.minPrice ?? null;
    parsedObj.optionPrice = statusDetails.optionPrice ?? null;
  }

  return parsedObj;
}
